import React from "react";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    title: "General Masters",
    subtitle: "Agencies, airlines and airports used across bookings",
    icon: "bi-grid-1x2-fill",
    items: [
      { label: "Agency Details", desc: "Manage travel agencies", icon: "bi-people-fill", tint: "#4f3df5", bg: "#eeecff", to: "/agency/list" },
      { label: "Airline", desc: "Carriers and airline codes", icon: "bi-airplane-fill", tint: "#0d6efd", bg: "#e7f0ff", to: "/airlines-details" },
      { label: "Airport", desc: "Airports and IATA codes", icon: "bi-airplane-engines-fill", tint: "#0ea5e9", bg: "#e0f4fd", to: "/airports-details" },
    ],
  },
  {
    title: "Location Master",
    subtitle: "Countries, states and cities for addresses and filters",
    icon: "bi-geo-alt-fill",
    items: [
      { label: "Country", desc: "Countries and phone codes", icon: "bi-globe", tint: "#16a34a", bg: "#e6f6ec", to: "/location/countries" },
      { label: "State", desc: "States by country", icon: "bi-map-fill", tint: "#f59e0b", bg: "#fef3e0", to: "/location/states" },
      { label: "City", desc: "Cities by state", icon: "bi-building", tint: "#e11d48", bg: "#fde8ed", to: "/location/cities" },
    ],
  },
  {
    title: "Master Configuration",
    subtitle: "Search and fare rules for flight APIs",
    icon: "bi-sliders",
    items: [
      { label: "Flight Api Search Restrictions", desc: "Limit API search results", icon: "bi-funnel-fill", tint: "#764ba2", bg: "#f3ebfa", to: null },
      { label: "Airline Search Restrictions", desc: "Block or allow airlines", icon: "bi-shield-fill-check", tint: "#764ba2", bg: "#f3ebfa", to: null },
      { label: "Flight Api Fare Types", desc: "Configure fare types", icon: "bi-tags-fill", tint: "#764ba2", bg: "#f3ebfa", to: null },
    ],
  },
];

const sectionCard = { background: "#fff", borderRadius: 14, border: "1px solid #e8ebf7", padding: 20, marginBottom: 20 };

const SettingTile = ({ item }) => {
  const disabled = !item.to;
  const content = (
    <>
      <span
        className="d-flex align-items-center justify-content-center flex-shrink-0"
        style={{ width: 44, height: 44, borderRadius: 12, background: item.bg, color: item.tint, fontSize: 18 }}
      >
        <i className={`bi ${item.icon}`}></i>
      </span>
      <span className="flex-grow-1" style={{ minWidth: 0 }}>
        <span className="d-block fw-semibold text-truncate" style={{ fontSize: 14, color: "#1a202c" }}>{item.label}</span>
        <span className="d-block text-truncate" style={{ fontSize: 12, color: "#8a9ab5" }}>{item.desc}</span>
      </span>
      {disabled ? (
        <span className="flex-shrink-0" style={{ fontSize: 10, fontWeight: 600, color: "#8a9ab5", background: "#f1f3f9", borderRadius: 20, padding: "3px 8px", textTransform: "uppercase", letterSpacing: 0.5 }}>
          Soon
        </span>
      ) : (
        <i className="bi bi-chevron-right setting-tile-arrow flex-shrink-0" style={{ fontSize: 13, color: "#b4bdd0" }}></i>
      )}
    </>
  );
  const className = `setting-tile d-flex align-items-center gap-3 h-100 text-decoration-none${disabled ? " is-disabled" : ""}`;
  return item.to ? (
    <Link to={item.to} className={className}>{content}</Link>
  ) : (
    <div className={className} title="Coming soon">{content}</div>
  );
};

const Setting = () => (
  <section className="section dashboard">
    <style>{`
      .setting-tile { background: #fff; border: 1px solid #e8ebf7; border-radius: 12px; padding: 14px 16px; transition: border-color .15s, box-shadow .15s, transform .15s; }
      .setting-tile:not(.is-disabled):hover { border-color: #c9c2fb; box-shadow: 0 6px 18px rgba(102, 126, 234, .14); transform: translateY(-2px); }
      .setting-tile:not(.is-disabled):hover .setting-tile-arrow { color: #4f3df5 !important; transform: translateX(2px); }
      .setting-tile-arrow { transition: color .15s, transform .15s; }
      .setting-tile.is-disabled { background: #fbfbfe; cursor: not-allowed; opacity: .75; }
    `}</style>

    <div className="mb-3">
      <h4 className="m-0 fw-bold" style={{ color: "#1a202c", fontSize: 20 }}>Settings</h4>
      <nav className="d-flex align-items-center gap-1 mt-1" style={{ fontSize: 12, color: "#8a9ab5" }}>
        <Link to="/" style={{ color: "#8a9ab5" }}><i className="bi bi-house-door"></i></Link>
        <i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i>
        <span className="fw-semibold" style={{ color: "#4a5568" }}>Settings</span>
      </nav>
    </div>

    {SECTIONS.map((section) => (
      <div key={section.title} style={sectionCard}>
        <div className="d-flex align-items-center gap-3 mb-3">
          <span
            className="d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "#fff", fontSize: 15 }}
          >
            <i className={`bi ${section.icon}`}></i>
          </span>
          <div>
            <h6 className="m-0 fw-bold" style={{ fontSize: 15, color: "#4b3f8f" }}>{section.title}</h6>
            <div style={{ fontSize: 12, color: "#8a9ab5" }}>{section.subtitle}</div>
          </div>
        </div>
        <div className="row g-3">
          {section.items.map((item) => (
            <div key={item.label} className="col-12 col-md-6 col-xl-4">
              <SettingTile item={item} />
            </div>
          ))}
        </div>
      </div>
    ))}
  </section>
);

export default Setting;
